<div class="ignite-otp-container">
  <ng-otp-input [formControl]="otpControl" [config]="otpConfig"></ng-otp-input>
</div>
 @if (config.showResend) {
  <div class="ignite-buttons-container">
    <div class="ignite-buttons">
      <div class="ignite-button-wrapper">
        <button mat-button class="ignite-button" color="primary" (click)="handleResendClick()">Resend code</button>
      </div>
    </div>
  </div>
  }
